/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import subDays from 'date-fns/sub_days';
import subHours from 'date-fns/sub_hours';
import startOfDay from 'date-fns/start_of_day';
import endOfDay from 'date-fns/end_of_day';
import addDays from 'date-fns/add_days';
import isAfter from 'date-fns/is_after';
import isBefore from 'date-fns/is_before';
import min from 'date-fns/min';
import DatePicker from 'loracoms/DatePicker';
import InlineSelect from 'loracoms/InlineSelect';
import IntlMsg from 'lorautils/intl/IntlMsg';
import dashboardActions from 'loraactions/dashboard';
import styles from './styles.scss';

const defaultTo = () => endOfDay(new Date());

const propTypes = {
  intl: PropTypes.object.isRequired,
  time: PropTypes.object.isRequired,
  getTimes: PropTypes.func.isRequired,
};

class TimeSelect extends React.Component {

  static handleDisableDate(d, from) {
    return isAfter(d, min(addDays(from, 7), new Date())) ||
      isBefore(d, from);
  }

  constructor(props) {
    super(props);
    this.state = {
      from: props.time.from,
      to: props.time.to,
      by: props.time.by || 'hour',
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.dashboard');
  }

  handleSetFrom(date) {
    this.setState({ from: startOfDay(date), to: endOfDay(date) }, () => {
      const { from, to } = this.state;
      this.props.getTimes({ from, to });
    });
  }

  handleSetTo(date) {
    this.setState({ to: startOfDay(date) }, () => {
      const { from, to } = this.state;
      this.props.getTimes({ from, to });
    });
  }

  handleChangeBy(by) {
    const { getTimes } = this.props;
    const to = defaultTo();
    let from;
    switch (by) {
      case 'hour':
        from = subHours(new Date(), 1);
        break;
      case 'day':
        from = subDays(new Date(), 1);
        break;
      case 'sevenday':
        from = subDays(new Date(), 7);
        break;
      case 'month':
        from = subDays(new Date(), 30);
        break;
      default:
        from = subHours(new Date(), 1);
    }
    this.setState({ by, from, to });
    getTimes({ from, to, by });
  }

  render() {
    const { from, to, by, selectDisabled } = this.state;
    return (
      <div className={`pull-right ${styles.gray}`}>
        <DatePicker
          date={from}
          onSelect={date => this.handleSetFrom(date)}
        />
        {' '}
        <DatePicker
          date={to}
          onSelect={date => this.handleSetTo(date)}
          disabled={d => TimeSelect.handleDisableDate(d, from)}
        />
        <InlineSelect
          bsStyle="aisz-primary"
          options={[{
            label: this.intlMsg.msg('toolbar.bytime.hour'),
            value: 'hour',
          }, {
            label: this.intlMsg.msg('toolbar.bytime.day'),
            value: 'day',
          }, {
            label: this.intlMsg.msg('toolbar.bytime.sevenday'),
            value: 'sevenday',
          }]}
          // , {
          //   label: this.intlMsg.msg('toolbar.bytime.month'),
          //   value: 'month',
          // }
          values={[by]}
          disabled={selectDisabled}
          onChange={selected => this.handleChangeBy(selected[0])}
        />
      </div>
    );
  }
}

TimeSelect.propTypes = propTypes;

const mapStateToProps = state => ({
  time: state.dashboard.getTimes,
});

const mapDispatchToProps = {
  getTimes: dashboardActions.getTimes,
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(TimeSelect));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DashBoardView/coms/TimeSelect/index.jsx